import { companyAnalysisQueryKeys } from "../queryKeyFactory";

import type { ICompanyAnalysisQueryClient, ICompanyAnalysisQueryClientDeps } from "./types";

export const createCompanyAnalysisQueryClient = ({
    queryClient,
}: ICompanyAnalysisQueryClientDeps): ICompanyAnalysisQueryClient => {
    const invalidateCompanyCardQueries = (): Promise<void> => {
        return queryClient.invalidateQueries({
            queryKey: companyAnalysisQueryKeys.companyCardBase(),
        });
    };

    const invalidateCompetitorsQueries = (): Promise<void> => {
        return queryClient.invalidateQueries({
            queryKey: companyAnalysisQueryKeys.competitorsBase(),
        });
    };

    return {
        invalidateCompanyCardQueries,
        invalidateCompetitorsQueries,
    };
};
